var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var PlusCircle = function PlusCircle(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '-13.1 16.8 18.1 18.1' }, props),
    React.createElement(
      'g',
      null,
      React.createElement(
        'title',
        null,
        'plus'
      ),
      React.createElement('path', { d: 'M-2.9 22.3h-1.9V25h-2.8v2h2.8v2.8h1.9V27h2.8v-2h-2.8z', className: 'st0' }),
      React.createElement('path', { d: 'M-4.1 16.8c-5 0-9 4.1-9 9 0 5 4.1 9.1 9 9.1s9-4.1 9-9.1c.1-5-4-9-9-9zm0 17.1c-4.4 0-8-3.6-8-8.1 0-4.4 3.6-8 8-8s8 3.6 8 8c.1 4.5-3.5 8.1-8 8.1z', className: 'st0'
      }),
      React.createElement('path', { id: 'Fill-2', d: 'M-7 25.8h6.2v.4H-7v-.4z', className: 'st0' })
    )
  );
};
/*eslint-enable */

export default PlusCircle;
//# sourceMappingURL=PlusCircle.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/PlusCircle.js